<template>
  <div id="tools" v-if="userinfo.isAdmin">
    <h1 class="mt-4" style="margin-bottom: 40px">Attributes</h1>
    <b-container>
      <div id="new">
        <b-button
          v-if="userinfo.isAdmin && userinfo.isActive"
          variant="primary"
          @click="newAttribute"
          style="margin-bottom: 40px"
          >New Attribute</b-button
        >
      </div>
      <b-form class="text-left" style="margin-bottom: 20px; text-align: right">
        <b-input-group size="" class="mb-2">
          <b-input-group-prepend is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input
            type="search"
            v-model="filter"
            placeholder="Search Attribute"
          ></b-form-input>
        </b-input-group>
      </b-form>
      <b-table
        :fields="fields"
        :items="attributes"
        hover
        outlined
        :sort-by.sync="sortBy"
        :filter="filter"
        sticky-header="500px"
        head-variant="light"
        style="white-space: nowrap"
      >
        <template #cell(action)="data">
          <!--
          <b-button size="sm" variant="primary" :href="`#/problem/${data.item.id}`">{{ data.value }}</b-button>
          -->
          <b-button
            size="sm"
            variant="success"
            @click="editfAttribute(data.item)"
            style="
              margin-left: 10px;
              font-family: Verdana, sans-serif !important;
            "
            >Edit Attribute</b-button
          >
          <b-button
            size="sm"
            variant="danger"
            @click="
              attribute_key = data.item.key;
              attribute_id = data.item.id;
              $refs['warning'].show();
            "
            style="
              margin-left: 10px;
              font-family: Verdana, sans-serif !important;
            "
            >Delete</b-button
          >
        </template>
      </b-table>
      <div id="new">
        <b-button
          v-if="userinfo.isAdmin && userinfo.isActive"
          variant="primary"
          @click="$refs['new_value'].show()"
          style="margin-top: 40px; margin-bottom: 40px"
          >New Attribute Value</b-button
        >
      </div>
      <b-row>
        <b-col cols="6" id="file_uploader">
          <b-form-file
            v-model="file1"
            accept="application/json"
            :state="Boolean(file1)"
            placeholder="Choose a JSON file"
            drop-placeholder="Drop file here..."
            style="margin-bottom: 20px; text-align: left; width: 100%"
            :disabled="uploading"
          ></b-form-file>
        </b-col>

        <b-col>
          <b-button
            :variant="uploading_variant"
            @click="upload_json"
            :disabled="DisUploadBtn"
            style="margin-bottom: 20px; width: 100%"
            >{{ uploading_msg }}</b-button
          >
        </b-col>
        <b-col>
          <b-button
            variant="primary"
            style="margin-bottom: 20px; width: 100%"
            :href="jsonURL"
            :download="jsonFilename"
            >Export</b-button
          >
        </b-col>
        <b-col>
          <b-button
            variant="primary"
            style="margin-bottom: 20px; width: 100%"
            @click="
              pubKey = undefined;
              priKey = undefined;
              $refs['generateKey'].show();
            "
            >Generate Key</b-button
          >
        </b-col>
        <b-tooltip target="file_uploader" triggers="hover">
          Example Content:<br />
          <code class="block whitespace-pre" style="text-align: left">
            {{ JSON.stringify(uploadTips, null, 4) }}</code
          >
        </b-tooltip>
      </b-row>

      <b-form class="text-left" style="margin-bottom: 20px; text-align: right">
        <b-input-group size="" class="mb-2">
          <b-input-group-prepend is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input
            type="search"
            v-model="filterValues"
            placeholder="Search Attribute Values"
          ></b-form-input>
        </b-input-group>
      </b-form>
      <div style="white-space: nowrap">
        <b-table
          :fields="userAttributefields"
          :items="attribute_values"
          hover
          outlined
          :sort-by.sync="sortBy"
          :filter="filterValues"
          sticky-header="500px"
          head-variant="light"
        >
          <template #cell(action)="data" style="">
            <!--
          <b-button size="sm" variant="primary" :href="`#/problem/${data.item.id}`">{{ data.value }}</b-button>
          -->
            <b-button
              size="sm"
              variant="success"
              @click="
                editAttributeValue(data.item);
                showGenerator = false;
              "
              style="
                margin-left: 10px;
                font-family: Verdana, sans-serif !important;
              "
              >Edit</b-button
            >
            <b-button
              size="sm"
              variant="danger"
              @click="
                delete_value_user = data.item.username;
                $refs['delete_value'].show();
              "
              style="
                margin-left: 10px;
                font-family: Verdana, sans-serif !important;
              "
              >Delete</b-button
            >
          </template>
        </b-table>
      </div>
      <b-modal
        ref="edit"
        id="edit"
        hide-footer
        :title="modal_title"
        size="lg"
        @submit="update_attribute"
      >
        <b-form
          style="text-align: left; margin-bottom: 10px"
          @submit="update_attribute"
        >
          <b-form-group
            id="input-group-1"
            label="Key"
            label-for="attribute_key"
          >
            <b-form-input
              id="attribute_key"
              type="text"
              v-model="attribute_key"
              :state="checkKeyEmpty"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-2"
            label="Description"
            label-for="attribute_desc"
          >
            <b-form-input
              id="attribute_desc"
              type="text"
              v-model="attribute_desc"
            ></b-form-input>
          </b-form-group>

          <b-button
            v-if="new_attribute"
            type="submit"
            variant="primary"
            class="mt-3"
            @click="update_attribute"
            :disabled="!checkKeyEmpty"
            >Add Attribute</b-button
          >
          <b-button
            v-else
            type="submit"
            variant="primary"
            class="mt-3"
            @click="update_attribute"
            :disabled="!checkKeyEmpty"
            >Update Attribute</b-button
          >
        </b-form>
      </b-modal>
      <b-modal
        ref="edit_value"
        id="edit_value"
        hide-footer
        :title="edit_username"
        size="lg"
      >
        <b-form style="text-align: left; margin-bottom: 10px">
          <div
            class="form-row"
            v-for="(attr, index) in attributes"
            :key="index"
            style="margin-bottom: 10px"
          >
            <b-input-group :prepend="attr.key" class="mt-2">
              <b-form-input
                v-model="edit_user_attribute_value[index]"
                :placeholder="attr.description"
              ></b-form-input>
            </b-input-group>
          </div>
          <center>
            <b-row>
              <b-col
                ><b-button
                  type="submit"
                  variant="success"
                  class="mt-3"
                  @click="update_attribute_value"
                  >Update Attribute Value</b-button
                ></b-col
              >
              <b-col
                ><b-button
                  variant="primary"
                  class="mt-3"
                  v-if="!showGenerator"
                  @click="showKeyGen()"
                  >Show Key Generator</b-button
                >
                <b-button
                  variant="primary"
                  class="mt-3"
                  v-else
                  @click="hideKeyGen()"
                  >Hide Key Generator</b-button
                ></b-col
              >
            </b-row>
          </center>
        </b-form>
        <div v-if="showGenerator">
          <hr class="mt-3" />
          <h3 class="mt-3">WireGuard Key Generator (Beta)</h3>
          <b-input-group prepend="Private Key" class="mt-3">
            <b-form-input
              placeholder=""
              v-model="priKey"
              readonly
            ></b-form-input>
            <b-input-group-append>
              <b-button variant="primary" @click="genKeypar()"
                >Generate</b-button
              >
            </b-input-group-append>
          </b-input-group>

          <b-input-group prepend="Public Key" class="mt-2">
            <b-form-input readonly v-model="pubKey"></b-form-input>
          </b-input-group>
        </div>
      </b-modal>
      <b-modal
        ref="new_value"
        id="new_value"
        hide-footer
        title="New Attribute Value"
        size="lg"
      >
        <b-form
          style="text-align: left; margin-bottom: 10px"
          @submit="new_attribute_value"
        >
          <div class="form-row" style="margin-bottom: 10px">
            <b-input-group prepend="username" class="mt-2">
              <b-form-input
                v-model="new_user_attribute_value['username']"
                required
              ></b-form-input>
            </b-input-group>
          </div>

          <div
            class="form-row"
            v-for="(attr, index) in attributes"
            :key="index"
            style="margin-bottom: 10px"
          >
            <b-input-group :prepend="attr.key" class="mt-2">
              <b-form-input
                v-model="new_user_attribute_value[attr.key]"
                :placeholder="attr.description"
              ></b-form-input>
            </b-input-group>
          </div>
          <center>
            <b-row>
              <b-col
                ><b-button type="submit" variant="primary" class="mt-3"
                  >Add Attribute Value</b-button
                ></b-col
              >
              <b-col
                ><b-button
                  variant="primary"
                  class="mt-3"
                  v-if="!showGenerator"
                  @click="showKeyGen()"
                  >Show Key Generator</b-button
                >
                <b-button
                  variant="primary"
                  class="mt-3"
                  v-else
                  @click="hideKeyGen()"
                  >Hide Key Generator</b-button
                ></b-col
              >
            </b-row>
          </center>
          <div v-if="showGenerator">
            <hr class="mt-3" />
            <h3 class="mt-3">WireGuard Key Generator (Beta)</h3>
            <b-input-group prepend="Private Key" class="mt-3">
              <b-form-input
                placeholder=""
                v-model="priKey"
                readonly
              ></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" @click="genKeypar()"
                  >Generate</b-button
                >
              </b-input-group-append>
            </b-input-group>

            <b-input-group prepend="Public Key" class="mt-2">
              <b-form-input readonly v-model="pubKey"></b-form-input>
            </b-input-group>
          </div>
        </b-form>
      </b-modal>
      <b-modal ref="warning" id="warning" hide-footer title="Warning">
        <div class="text-center" style="font-size: 1.2rem">
          <p>This action will delete attribute "{{ attribute_key }}".</p>
          <p>Are you sure?</p>
        </div>
        <div class="col text-center">
          <b-button
            class="mt-3"
            variant="primary"
            @click="self.$refs['warning'].hide()"
            >No!</b-button
          >
          <b-button
            class="mt-3"
            variant="danger"
            @click="deleteAttribute(attribute_id)"
            style="margin-left: 10px"
            >Delete!</b-button
          >
        </div>
      </b-modal>
      <b-modal ref="delete_value" id="delete_value" hide-footer title="Warning">
        <div class="text-center" style="font-size: 1.2rem">
          <p>
            This action will delete all attribute values for user "{{
              delete_value_user
            }}".
          </p>
          <p>Are You Sure?</p>
        </div>
        <div class="col text-center">
          <b-button
            class="mt-3"
            variant="primary"
            @click="self.$refs['warning'].hide()"
            >No!</b-button
          >
          <b-button
            class="mt-3"
            variant="danger"
            @click="deleteAttributeValue"
            style="margin-left: 10px"
            >Delete!</b-button
          >
        </div>
      </b-modal>
      <b-modal
        ref="generateKey"
        id="generateKey"
        hide-footer
        title="WireGuard Key Generator (Beta)"
        size="lg"
      >
        <b-input-group prepend="Private Key" class="mt-2">
          <b-form-input placeholder="" v-model="priKey" readonly></b-form-input>
          <b-input-group-append>
            <b-button variant="primary" @click="genKeypar()">Generate</b-button>
          </b-input-group-append>
        </b-input-group>

        <b-input-group prepend="Public Key" class="mt-2">
          <b-form-input readonly v-model="pubKey"></b-form-input>
        </b-input-group>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
import wireguard from "@/tools/wireguard";

export default {
  created() {
    this.get_user_info();
    this.get_user_list();
    this.get_attributes();
  },
  beforeMount() {
    let self = this;
    this.$bus.$on("isAdmin", (event) => {
      self.is_admin = event.is_admin;
    });
  },
  mounted() {},
  beforeDestroy() {
    this.$bus.$off("isAdmin");
  },
  computed: {
    checkKeyEmpty() {
      return (
        isNaN(this.attribute_key) &&
        (this.attribute_key.length > 0 ? true : false)
      );
    },
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: false,
        },
        {
          key: "key",
          label: "key",
        },
        {
          key: "description",
          label: "Description",
        },
        {
          key: "action",
          label: "Action",
        },
      ],
      userAttributefields: [
        {
          key: "username",
          label: "User Name",
          stickyColumn: true,
          variant: "primary",
          sortable: true,
        },
      ],
      items: [],
      sortBy: "id",
      origin_attributes_num: 0,
      userinfo: {
        isAdmin: false,
        isActive: false,
      },
      filter: "",
      filterValues: "",
      attributes: [],
      project_id: 0,
      branch: "",
      job_name: "",
      cooldown_time: 0,
      new_attribute: true,
      modal_title: "",
      attribute_key: "",
      attribute_id: 0,
      attribute_desc: "",
      project_url: [],
      attribute_values: [],
      attribute_values_display: [],
      user_list: [],
      attributes_orgin: [],
      user_attribute_value: [],
      edit_user_attribute_value: [],
      edit_username: "",
      delete_value_user: "",
      new_user_attribute: "",
      new_user_attribute_value: [],
      file1: "",
      uploading: false,
      uploading_msg: "Upload",
      uploadTips: [],
      jsonFilename: undefined,
      jsonURL: undefined,
      DisUploadBtn: true,
      priKey: undefined,
      pubKey: undefined,
      showGenerator: false,
      uploading_variant: "success",
    };
  },
  watch: {
    file1: function () {
      if (this.file1.name == undefined) {
        this.DisUploadBtn = true;
      } else if (this.uploading) {
        this.DisUploadBtn = true;
      } else {
        this.DisUploadBtn = false;
      }
    },
  },
  methods: {
    showKeyGen() {
      this.showGenerator = true;
    },
    hideKeyGen() {
      this.showGenerator = false;
    },
    genKeypar() {
      let self = this;
      let priKey = wireguard.generatePrivateKey();
      let pubKey = wireguard.generatePublicKey(priKey);
      self.priKey = wireguard.keyToBase64(priKey);
      self.pubKey = wireguard.keyToBase64(pubKey);
    },
    editAttribute(item) {
      let self = this;
      this.attribute_id = item.id;
      this.attribute_key = item.key;
      this.attribute_desc = item.description;
      this.modal_title = "Edit Attribute";
      this.new_attribute = false;
      self.$refs["edit"].show();
    },
    newAttribute() {
      let self = this;
      this.attribute_id = 0;
      this.attribute_key = "";
      this.attribute_desc = "";
      this.modal_title = "New Attribute";
      this.new_attribute = true;
      self.$refs["edit"].show();
    },
    deleteAttribute(id) {
      let self = this;
      let api = "/attribute/";
      let access_token = localStorage.getItem("access_token");

      this.$http
        .delete(api + id, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          if (response != undefined) {
            self.get_attributes();
            self.get_attribute_values();
            self.$refs["warning"].hide();
          }
        })
        .catch(function (error) {
          if (error.response) {
            //console.log(error);
          }
        });
    },
    getAttrIndex(key) {
      return this.user_attribute_value.findIndex(function (e) {
        return e.key == key;
      });
    },
    editAttributeValue(item) {
      let self = this;
      //this.attribute_id = item.id;
      //this.attribute_key = item.key;
      //this.attribute_desc = item.description;
      //this.modal_title = "Edit Attribute";
      //this.new_attribute = false;
      let api = "/attribute/value/" + item.username;
      let access_token = localStorage.getItem("access_token");
      this.edit_username = item.username;

      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          self.edit_user_attribute_value = [];
          self.user_attribute_value = response.data;
          self.attributes.forEach(function (attr) {
            //console.log(self.user_attribute_value[self.getAttrIndex(attr.key)]);
            self.edit_user_attribute_value.push(
              self.user_attribute_value[self.getAttrIndex(attr.key)].value
            );
          });
        })
        .catch(function (error) {
          if (error.response) {
            //console.log(error);
          }
        });
      self.$refs["edit_value"].show();
    },
    new_attribute_value() {
      let self = this;
      let api =
        "/attribute/value/" + self.new_user_attribute_value["username"] + "/";
      let access_token = localStorage.getItem("access_token");
      self.attributes.forEach(function (attr) {
        let data = {
          value: self.new_user_attribute_value[attr.key],
        };
        //console.log(attr);
        self.$http
          .post(api + attr.key, data, {
            headers: {
              Authorization: "Bearer " + access_token,
            },
          })
          .then(() => {
            self.get_attribute_values();
          })
          .catch(function (error) {
            if (error.response) {
              //console.log(error);
            }
          });
      });
      self.get_attribute_values();
      self.$refs["new_value"].hide();
    },
    update_attribute_value() {
      let self = this;
      let api = "/attribute/value/" + self.edit_username + "/";
      let access_token = localStorage.getItem("access_token");
      self.attributes.forEach(function (attr, i) {
        let data = {
          value: self.edit_user_attribute_value[i],
        };
        //console.log(attr);
        self.$http
          .patch(api + attr.key, data, {
            headers: {
              Authorization: "Bearer " + access_token,
            },
          })
          .then(() => {
            self.get_attribute_values();
            self.$refs["edit_value"].hide();
          })
          .catch(function (error) {
            if (error.response) {
              //console.log(error);
            }
          });
      });
    },
    deleteAttributeValue() {
      let self = this;
      let api = "/attribute/value/" + this.delete_value_user + "/";
      let access_token = localStorage.getItem("access_token");
      self.attributes.forEach(function (attr) {
        self.$http
          .delete(api + attr.key, {
            headers: {
              Authorization: "Bearer " + access_token,
            },
          })
          .then(() => {
            self.get_attribute_values();
          })
          .catch(function (error) {
            if (error.response) {
              //console.log(error);
            }
          });
      });

      self.$refs["delete_value"].hide();
    },
    get_user_info() {
      let self = this;
      let api = "/user/me";
      this.access_token = localStorage.getItem("access_token");
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + this.access_token,
          },
        })
        .then((response) => {
          self.userinfo = response.data;
          if (!self.userinfo.isAdmin) {
            self.$router.push({ name: "Home" });
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status == 422) {
              localStorage.clear();
              self.$router.push({ name: "Home" });
            }
          }
        });
    },
    toComponent(c_name) {
      let userinfo = this.userinfo;
      this.$router.push({
        name: c_name,
        params: { userinfo },
      });
    },
    get_attributes() {
      let self = this;
      let access_token = localStorage.getItem("access_token");
      let api = "/attribute/";
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          self.attributes_orgin = response.data;
          (self.userAttributefields = [
            {
              key: "username",
              label: "User Name",
              stickyColumn: true,
              variant: "primary",
              sortable: true,
            },
          ]),
            (self.attributes = response.data.sort(function (a, b) {
              return a.id > b.id ? 1 : -1;
            }));
          self.attributes.forEach(function (item) {
            self.userAttributefields.push({
              key: item.key,
              label: item.key,
              sortable: true,
            });
          });
          self.userAttributefields.push({
            key: "action",
            label: "Action",
          });
          self.origin_attributes_num = response.data.length;
          self.get_attribute_values();
          self.upload_tips();
        });
    },
    get_user_list() {
      let self = this;
      let api = "/user/";
      let access_token = localStorage.getItem("access_token");
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          self.user_list = response.data;
        });
    },
    get_attribute_values() {
      let self = this;
      let access_token = localStorage.getItem("access_token");
      let api = "/attribute/value2";
      let now = new Date();
      let offsetMs = now.getTimezoneOffset() * 60 * 1000;
      let dateLocal = new Date(now.getTime() - offsetMs);
      let str = dateLocal.toISOString().slice(0, 19);
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          self.attribute_values = response.data.sort(function (a, b) {
            return a.username > b.username ? 1 : -1;
          });
          let data = encodeURIComponent(
            JSON.stringify(self.attribute_values, null, 2)
          );
          self.jsonURL = `data:application/json;charset=utf-8,${data}`;
          self.jsonFilename = str + "-Sysjudge-AttributeValues.json";
        });
    },
    get_user_attribute_value(username) {
      let self = this;
      //console.log(username);
      let access_token = localStorage.getItem("access_token");
      let api = "/attribute/value/" + username;

      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          self.user_attribute_value = response.data;
        });
    },
    get_project_url(id) {
      let access_token = localStorage.getItem("access_token");
      let api = "/debug/" + id + "/url";
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          window.open(response.data, "_blank").focus();
        });
    },
    update_attribute() {
      let self = this;
      let access_token = localStorage.getItem("access_token");
      let api = "/attribute/";
      let data = {
        key: this.attribute_key.toUpperCase(),
        description: this.attribute_desc,
      };
      if (this.attribute_id == 0) {
        self.$http
          .post(api, data, {
            headers: {
              Authorization: "Bearer " + access_token,
            },
          })
          .then(() => {
            self.get_attributes();
            self.$refs["edit"].hide();
            self.get_attribute_values();
          })
          .catch(function (error) {
            if (error.response) {
              //console.log(error);
            }
          });
      } else {
        self.$http
          .patch(api + self.attribute_id, data, {
            headers: {
              Authorization: "Bearer " + access_token,
            },
          })
          .then(() => {
            self.get_attributes();
            self.$refs["edit"].hide();
            self.get_attribute_values();
          })
          .catch(function (error) {
            if (error.response) {
              //console.log(error);
            }
          });
      }
    },
    upload_json() {
      let self = this;
      let access_token = localStorage.getItem("access_token");
      let api = "attribute/value/json";
      let formData = new FormData();
      self.uploading = true;
      self.DisUploadBtn = true;
      self.uploading_variant = "success";
      let dots = "";
      let timeInterval = setInterval(function () {
        if (dots.length < 3) {
          dots += ".";
          self.uploading_msg = "Uploading" + dots;
        } else {
          dots = "";
          self.uploading_msg = "Uploading";
        }
      }, 300);

      formData.append("file", self.file1);
      this.$http
        .post(api, formData, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then(() => {
          clearInterval(timeInterval);
          self.uploading_msg = "Success!";
          self.get_attributes();
          self.get_attribute_values();
          self.uploading = false;
          self.DisUploadBtn = false;
        })
        .catch(function (error) {
          if (error.response.status == 415) {
            clearInterval(timeInterval);
            self.uploading_variant = "danger";
            self.uploading_msg = "Invalid JSON!";
            self.DisUploadBtn = true;
            self.file1 = "";
            let s = 1;
            let timeInterval2 = setInterval(function () {
              if (s == 1) {
                s=0;
              } else {
                self.uploading_msg = "Upload";
                self.uploading_variant = "success";
                self.uploading = false;
                self.DisUploadBtn = false;
                clearInterval(timeInterval2);
              }
            }, 1000);
          }
        });
    },
    upload_tips() {
      this.uploadTips = [];
      let json = {};
      json["username"] = "Username";
      this.attributes.forEach(function (item) {
        json[item.key] = "Someting";
      });
      this.uploadTips.push(json);
      this.uploadTips.push(json);
    },
  },
};
</script>

<style>
.tooltip-inner {
  min-width: 400px;
  /* If max-width does not work, try using width instead */
  width: 500px;
  font-weight: bold;
  text-align: left !important;
  white-space: pre;
}
</style>